
import PageHeading from "@/components/other/PageHeading/PageHeading.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ClassPageHeading",
  components: { PageHeading },
});
